module.exports = __webpack_public_path__ + "img/BatAgriSerreO.336a3e91.png";